function mapContentToWords(content) {
  let currentWordCharacters = [];
  const output = [];
  for (const node of content) {
    switch (node.nodeType) {
      case "selectable-character-input":
        currentWordCharacters.push(node);
        break;
      case "mark-characters-whitespace":
        {
          if (currentWordCharacters.length > 0) {
            output.push({
              nodeType: "word",
              characters: currentWordCharacters
            });
            currentWordCharacters = [];
          }
          output.push(node);
          break;
        }
    }
  }
  if (currentWordCharacters.length > 0) {
    output.push({
      nodeType: "word",
      characters: currentWordCharacters
    });
  }
  while (output.length && output.at(-1)?.nodeType === "mark-characters-whitespace") {
    output.splice(output.length - 1, 1);
  }
  return output;
}

export { mapContentToWords };
//# sourceMappingURL=util.map-content-to-words.js.map
